<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<app-header-card [title]="'Tournament Tables Overview'">
  <div class="action-buttons">
    <button mat-raised-button color="primary" (click)="backToOverview()">Back to Overview</button>
    <button mat-flat-button color="primary" class="createButton" (click)="createBeerPongTable()">
      Create Beer Pong Table
    </button>
  </div>
</app-header-card>

<div class="table-container" data-cy="beer-pong-tables-list">
  <table mat-table [dataSource]="tables()" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Table Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="editBeerPongTable(element.id)">
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="openConfirmDialog(element.id)"
          data-cy="delete-beer-pong-table-btn"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      data-cy="beer-pong-tables-list-item"
    ></tr>
  </table>
</div>
